<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de indicadores SAD">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-indicador-sad/List'

export default {
    components: { List },
}
</script>